import React, {useMemo, useCallback, useState, useEffect} from "react"
import {useSelector, useDispatch} from "react-redux"
import {Transition} from "react-transition-group"
import alertify from "alertifyjs"

import LeftWorkHeader from "../LeftWorkHeader/LeftWorkHeader"
import SizeBtn from "./SizeBtn"

import {
  setProduct2dBaseColor,
  setLeftWorkAreaState,
  setProduct2d,
} from "../../../redux/actions/product2dActions"

import "./leftworksize.scss"

// import {colors} from "../../../constants/utils"

const transitionStyles = {
  entering: {opacity: 0},
  entered: {opacity: 1, position: "relative"},
  exiting: {opacity: 0},
  exited: {opacity: 0},
}
/**
 * Button on left panel. This button toggle menu for work with text and images
 * @component
 * @param {object} props
 * @param {boolean} props.active=false - size winndow state
 * @param {boolean} props.size=false - flag for size
 *
 * @example
 * const size = 'L'
 * const active = false
 *
 * return (
 *  <LeftWorkSize
 *  size={size}
 *  active={active}
 *  />
 * )
 */

const LeftWorkSize = props => {
  const {active, size = "L"} = props
  const dispatch = useDispatch()
  const product2d = useSelector(state => state.product2d)
  const makFabric = useSelector(state => state.makFabric)

  const products =  useSelector(({ products }) => products);
  const { sizeColorMapping,skuArray } = products
  const sizes = sizeColorMapping ? Object.keys(sizeColorMapping).map((size) => ({
    size,
    label: size
  })) : [];

  const [currentSize, setCurrentSize] = useState({
    size: sizes.length ? sizes[0].size : size,
    label: sizes.length ? sizes[0].size : size,
  });

  useEffect(() => {
    setCurrentSize({
      size: product2d.size,
      label: product2d.size
  })
  }, [product2d])

  const handleSelectSize = useCallback(
    e => {
      console.log("In handleSelectSize");
      if (size) {

        const newSelection = skuArray.find(item=>{
          return (item.color === product2d.color ) && (item.size === e.target.dataset.size)
        })

        if(!newSelection){
          const newSize = e.target.dataset.size;
          const newLabel = e.target.dataset.value;
          alertify.confirm('Sorry! The selected size is unavailable for the current color. Do you still wish to proceed?', () => {
            setCurrentSize({
              size: newSize,
              label: newLabel,
            })

            const color = sizeColorMapping[newSize][0].color;

            const newDefaultSelection = skuArray.find(item => {
              return (item.color === color) && (item.size === newSize)
            })

            const selection = {
              ...product2d,
              color,
              variationSKU: newDefaultSelection.sku,
              price: newDefaultSelection.price,
              size: newSize
            }
            dispatch(setProduct2d(selection))
            makFabric.setBaseColor(color)
          });
          return
        }

        setCurrentSize({
          size: e.target.dataset.size,
          label: e.target.dataset.value,
        })

        const selection = {
          ...product2d,
          variationSKU: newSelection.sku,
          price: newSelection.price,
          size: e.target.dataset.size
        }

        console.log(selection)

        dispatch(setProduct2d(selection))

        // size = currentSize.size
      }
    },
    [dispatch, makFabric, size, product2d, skuArray, product2d],
  )

  // console.log(textC)

  const renderSizes = useMemo(
    () =>
      sizes.map(item => (
        <SizeBtn
          key={item.size}
          size={item.size}
          title={item.label}
          active={
            currentSize.size === item.size
          }
          handler={handleSelectSize}
        />
      )),
    [handleSelectSize, currentSize.size, sizes],
  )

  // const backToEdit = () => {
  //   dispatch(setLeftWorkAreaState("EDIT_TEXT"))
  // }

  // useEffect(() => {
  //   if (makFabric) {
  //     makFabric.getSelectedText() &&
  //       setTextC(
  //         sizes.find(item => item.color === makFabric.getSelectedText()),
  //       )
  //   }
  // }, [makFabric])

  return (
    <Transition
      in={active}
      timeout={200}
      unmountOnExit={true}
      mountOnEnter={true}
    >
      {state => (
        <div
          className="leftWorkSizeContainer"
          style={{
            ...transitionStyles[state],
          }}
        >
          <LeftWorkHeader
            title={size ? "Size" : "Choose Size"}
            activeHandler={size}
            // handler={backToEdit}
          />
          <div className="leftWorkSizeContent">
            <div className="leftWorkSizeTitle">
              <span>{size === ""  ? "Size: " : "Selected Size:"}</span>
              <div
                className="leftWorkSizeTitle_size"
                style={{
                  display:"flex",
                  alignItems:"center",
                  justifyContent:"center",
                  backgroundColor: "transparent"
                }}
              >{currentSize.label}</div>
            </div>
            <div className="leftWorkSizeSizesContainer">{renderSizes}</div>
          </div>
        </div>
      )}
    </Transition>
  )
}

export default LeftWorkSize
